export const demoDataChartLabels = ['Baghdad', 'Erbil', 'Najaf', 'Anbar'];

export const demoDataChartNumbers = [48, 10, 18, 36];
